const currencyConverter = [
  { case: '', currencyCode: '' },
  { case: 'ID', currencyCode: 'IDR' },
  { case: 'PH', currencyCode: 'PHP' }
]

export const isoCodeConversion = (target) => {
  let obj = currencyConverter.find(item => item.case === target)
  return obj.currencyCode
}



// WEBPACK FOOTER //
// ./src/Utils/ConversionUtils.js